// extracted by mini-css-extract-plugin
export var background = "styles-module--background--6419e";
export var button = "styles-module--button--19152";
export var container = "styles-module--container--6d7dd";
export var foreground = "styles-module--foreground--52d0e";
export var imgDesktop = "styles-module--imgDesktop--a40eb";
export var imgMobile = "styles-module--imgMobile--0ee06";
export var text = "styles-module--text--a4d32";
export var wrapper = "styles-module--wrapper--b963a";